import { useContext, useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import UserContext from "../../contexts/UserContext";
import FetchUtil from "../../utils/FetchUtil";
import { useTranslation } from 'react-i18next';

function Landing() {
	const userCtx = useContext(UserContext);
	const { t } = useTranslation();
	const navigate = useNavigate();

	const [searchParams, setSearchParams] = useSearchParams();

	useEffect(() => {
		userCtx.addUserName("");
		userCtx.addLoggedInUserId("");
		userCtx.addRole("");
		userCtx.addIsAuthenticated(false);
		userCtx.addLang("");
		userCtx.addTosTimeStamp("");
		userCtx.addEnabledMFA(0);
		userCtx.clearStorage();
		checkAuth();
	}, []);
  	
	function checkAuth() {
	   	const requestOptions = {
	         credentials: "same-origin",
	         method: "POST",
	         headers: { "Content-Type": "application/json" },
	         body: JSON.stringify({ "source": "web" }),
	  	};
	  	try{
         	FetchUtil.fetchAPI("CheckAuth","/Service/StaticNav/CheckAuth", requestOptions, checkAuthSuccess, checkAuthFail);
      	} catch (error) {
         	navigate("/",{
	        	state: {
	            	errorMessage: error.message,
	        	},
	     	});
      	}
	}
	function checkAuthFail(redirect){
		navigate("/",{
		        state: {
		            	errorMessage: t("error.userAuthFailed"),
		        	},
		     });
  	}
  	
  	function checkAuthSuccess(responseData){
		let logonServiceResponse;
      	if (responseData) {
			logonServiceResponse = responseData.logonServiceResponse;
			if(! logonServiceResponse){
				logonServiceResponse = responseData.logonResponse;
			}
	        if (logonServiceResponse && logonServiceResponse.errorCode === "0") {
				userCtx.addUserName(logonServiceResponse.userName);
				userCtx.addLoggedInUserId(logonServiceResponse.userId);
				userCtx.addRole(logonServiceResponse.userRole);
				userCtx.addIsAuthenticated(true);
				userCtx.addLang(logonServiceResponse.userLanguage);
				userCtx.addTosTimeStamp(logonServiceResponse.tosTimeStamp);
				userCtx.addEnabledMFA(logonServiceResponse.enabledMFA);
				navigate("/home_signin");
	        } else if (logonServiceResponse.errorCode === "114"){
				navigate("/",{
			        state: {
			            	errorMessage: t("error.sessionTimeout"),
			        	},
			     });
			} else if (logonServiceResponse.errorCode === "1"){
				navigate("/",{
			        state: {
			            	errorMessage: "",
			        	},
			     });
			} else {
				navigate("/",{
			        state: {
			            	errorMessage: t("error.userAuthFailed") + " " +logonServiceResponse.errorMessage,
			        	},
			     });
			  	
	        }
      	}
  	}
	    
  	return (
	    <div />
  	);
}
export default Landing;
